
import React, { Component } from 'react';
import { Modal, Form, Input } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';

import OrgSelect from '../../ui/OrgSelect';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "所属会员",
    "field": "memberCode",
    "member": true,
}, {
    "text": "参数编码",
    "field": "code",
    rules: [
        { required: true, message: '参数编码不能为空!' },
        { max: 32, message: '参数编码不能超过32个字符！' },
    ]
}, {
    "text": "参数名称",
    "field": "name",
    rules: [
        { required: true, message: '参数名称不能为空!' },
        { max: 64, message: '参数名称不能超过64个字符！' },
    ]
}, {
    "text": "参数值",
    "field": "value",
    rules: [
        { required: true, message: '参数值不能为空!' },
        { max: 2048, message: '参数值不能超过2048个字符！' },
    ],
    textarea: true
}, {
    "text": "备注",
    "field": "remark",
    rules: [
        { max: 64, message: '参数名称不能超过64个字符！' },
    ],
    textarea: true
}];


class MemberParamEditForm extends Component {

    state = {
        orgCode: null,
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            http.post({
                url: '/memberParam/saveMemberParam',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    onSelect = (key) => {
        this.setState({ orgCode: key });
        this.memberRef.loadMeterInfo({orgCode: key});
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let orgCode = this.state.orgCode ? this.state.orgCode : editData.orgCode;
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.member ? <MemberSelect orgCode={orgCode} onRef={(ref) => { this.memberRef = ref }} allowClear={true} />
                                // : item.org ? <TreeSelect treeData={this.props.orgList} treeDefaultExpandAll={true} onChange={this.onSelect} />
                                : item.org ?  <OrgSelect onChange={this.onSelect} treeDefaultExpandAll={true}/>
                                    : item.textarea ? <Input.TextArea />
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="会员参数编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const MemberParamEdit = Form.create()(MemberParamEditForm);

export default MemberParamEdit;